var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor messenger-send-message" }, [
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Message Type"),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "classic-new-select",
            attrs: { placeholder: "Select Message Type" },
            model: {
              value: _vm.clone.messageType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "messageType", $$v)
              },
              expression: "clone.messageType",
            },
          },
          _vm._l(_vm.messageTypes, function (messageType) {
            return _c(
              "a-select-option",
              { key: messageType.type, attrs: { value: messageType.type } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(messageType.text) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Channel")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "classic-new-select",
            attrs: { placeholder: "Select Messenger Channel" },
            model: {
              value: _vm.clone.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "channelId", $$v)
              },
              expression: "clone.channelId",
            },
          },
          _vm._l(_vm.messengerChannels, function (channel) {
            return _c(
              "a-select-option",
              { key: channel._id, attrs: { value: channel._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(channel.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("User ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "User ID",
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.userId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "userId", $$v)
            },
            expression: "clone.userId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.messageType === "text"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor" },
          [
            _c("div", { staticClass: "editor-row-title" }, [_vm._v("Message")]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Message",
                "show-attributes": true,
                "max-character-count": 2048,
              },
              model: {
                value: _vm.clone.message,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "message", $$v)
                },
                expression: "clone.message",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.messageType === "image"
      ? _c("div", { staticClass: "image-picker" }, [
          _c("div", { staticClass: "editor-row" }, [
            _c("div", { staticClass: "editor-row-title" }, [_vm._v("Media")]),
            _vm._v(" "),
            _vm.media
              ? _c("div", { staticClass: "media-preview" }, [
                  _c("div", { staticClass: "media-preview-content" }, [
                    _c("div", { staticClass: "media-image" }, [
                      _c("img", { attrs: { src: _vm.media.data, alt: "" } }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "media-preview-name" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.media.name) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "media-preview-delete",
                      on: { click: _vm.deleteMedia },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("delete"),
                      ]),
                    ]
                  ),
                ])
              : _c("div", { staticClass: "media-drag" }, [
                  _c("div", { staticClass: "input" }, [
                    _c("input", {
                      attrs: { type: "file", id: "media-source" },
                      on: { change: _vm.handleFileUpload },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("image"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm._v("Click here to upload a picture."),
                  ]),
                ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }